import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  FormEmail,
} from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../Button';
import CheckAll from '../../CheckAll';

export interface SearchOcularExportProps {
  isLoading: boolean;
  className?: string;
}

import './style.scss';

const SearchOcularExport: React.FC<SearchOcularExportProps> = (props) => {
  const { className, isLoading } = props;
  const { t } = useTranslation();
  const classNames = c('SearchOcularDB__Export', className);

  return (
    <div className={classNames}>
      <h3 className="SearchOcularDB__Export__title">{t('components.search_oculardb.export.title')}</h3>
      <CheckAll />

      <FormEmail
        title={t('components.search_oculardb.export.email')}
        fieldName="email"
        placeholder={t('components.search_oculardb.export.email')}
      />

      <Button className="SearchAllContent__Export__submit" type="secondary" htmlType="submit" loading={isLoading}>
        {t('components.export.export')} <span className="loader">⏳</span>
      </Button>
    </div>
  );
};

export default SearchOcularExport;
